export default "__VITE_ASSET__DnZNKuA7__"